enum ContentTypes {
    Asset = 1,
    InteractiveAsset = 2,
    VideoPlaylist = 3,
    Test = 4,
    Certification = 5,
    TeacherCourseAssessment = 6
}

export default ContentTypes;
